const ScanStyle = {
  rootScan: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    // borderRadius:'16px'
  },
  rednfc: {
    backgroundImage:
      'radial-gradient(89.58% 89.58% at 50% 0%, rgba(216, 29, 93, 0.2) 0%, rgba(255, 255, 255, 0.0001) 100%);',
  },
  bluesucces: {
    backgroundImage:
      'radial-gradient(89.58% 89.58% at 50% 0%, rgba(60, 192, 195, 0.3) 0%, rgba(255, 255, 255, 0.0001) 100%);',
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },

  container: {
    // position:'fixed',
    // top:'30%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '190px',
    height: '190px',
    padding: '12px',
    boxShadow: 'inset 0 5px 15px 0 rgba(0, 0, 0, 0.2)',
    border: 'solid 1px #ffffff',
    backgroundColor: '#f5f5f5',
    borderRadius: '50%',

    // marginLeft:'20px'
  },
  buttonContain: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rotate: {
    animation: `spin 3s linear infinite`,
  },
  circle: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '150px',
    height: '150px',
    boxShadow:
      '-15px 15px 25px 0 rgba(172, 172, 172, 0.5), -15px -15px 25px 0 #ffffff',
    // border: 'solid 1px #ffffff',
    backgroundImage:
      'linear-gradient(340deg, rgba(19,201,244,1) 0%, rgba(113,66,192,1) 61%, rgba(117,60,190,1) 100%)',
    borderRadius: '50%',
  },
  circle2: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'end',
    width: '150px',
    height: '150px',
    boxShadow:
      '-15px 15px 25px 0 rgba(172, 172, 172, 0.5), -15px -15px 25px 0 #ffffff',
    overflow: 'hidden',
    // backgroundColor:'red',
    //added in scanCss.css instead of hear
    // backgroundImage: `url(${img})`,
    // backgroundRepeat: 'repeat-x',
    // animation: 'animate 10s linear infinite',
    // border: 'solid 1px #ffffff',
    // backgroundImage:'linear-gradient(340deg, rgba(19,201,244,1) 0%, rgba(113,66,192,1) 61%, rgba(117,60,190,1) 100%)',
    borderRadius: '50%',
  },

  circleSuccess: {
    backgroundImage:
      'linear-gradient(340deg, #13c9f4 0%, #38d18b 61%, #3cbe46 100%)',
    animation: `bounce 3s linear infinite`,
  },
  circleError: {
    backgroundImage: 'linear-gradient(250deg, #d81d5d 20%, #ea79a0 80%)',
  },
  containerUl: {
    textAlign: 'center',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  scan: {
    fontSize: '24px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#4e4e4e',
    margin: 0,
    // height:0,
    position: 'absolute',
    bottom: '35%',
  },
  title: {
    width: '100%',

    fontSize: '16px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#707070',
  },
  Nfc: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: '40px',
  },
  NfcText: {
    fontSize: '16px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#707070',
    marginTop: '20px',
  },
  NfcLength: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',

    fontSize: '14px',
    fontWeight: 'bold',
    color: '#3bba4c',
    marginTop: '10px',
  },
  NfcLengthText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',

    fontSize: '14px',
    fontWeight: 'normal',
    color: '#3bba4c',
    marginTop: '10px',
  },
  titleMobile: {
    // position:'fixed',
    // bottom:'20%',
    width: '200px',
    height: '20px',

    fontSize: '16px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#707070',
    marginTop: '50px',
  },
  titleMobileContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  purple: {
    color: '#753cbe',
  },

  viewReport: {
    // position:'fixed',
    // bottom:'10%',
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    // marginTop:'100%'
  },
  fix: {
    position: 'fixed',
    top: '30%',
  },
  ButtonStyle: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    width: '246px',
    height: '48px',
    padding: '14px 26px 14px 25px',
    boxShadow:
      '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5)',
    border: 'solid 1px #ffffff',
    backgroundColor: '#f5f5f5',
    borderRadius: '16px !important',
    textAlign: 'center',
    margin: 'auto !important',
    marginTop: '30px !important',
    color: '#753cbe',
  },
  ButtonLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#753cbe !important',
  },
  backTime: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#707070',

    fontSize: '16px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    textAlign: 'center',
  },
  //    newwwwwww
  center: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    alignItems: 'center',
  },
  rootContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '32px',
    paddingTop: '15px',
  },
  circleList: {
    width: '15px !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '3px !important',
  },
  lineContainer: {
    marginBottom: '17px',
  },
  normalState: {
    fontSize: '14px',
    color: '#222222',
    fontWeight: '400',
    // opacity: '30%'
  },
  errorText: {
    color: '#d81d5d !important',
  },
  processing: {
    color: '#8144ca',
    fontFamily: 'dana-bold',
  },
  processingIcon: {
    color: '#8144ca',
    fontSize: '6px !important',
  },
  done: {
    color: '#3cc0c3',
    fontFamily: 'dana-bold',
  },
  doneTik: {
    color: '#3cc0c3',
    fontSize: '15px !important',
  },
  errorIcon: {
    color: '#d81d5d',
    fontSize: '15px !important',
  },
  purplebold: {
    color: '#753cbe',
    fontSize: '16px',
    fontFamily: 'dana-bold',

    // marginTop:'7px',
    lineHeight: '25px',
  },
  errorContainer: {
    marginTop: '17xpx',
  },
  errorMessage: {
    color: '#d81d5d',
    fontWeight: 'bold',
    fontSize: '14px',
    marginTop: '20px',
    textAlign: 'center',
  },
  totalSize: {
    display: 'flex',
    justifyContent: 'center',
    color: '#753cbe',

    fontWeight: 'bold',
    fontSize: '24px',
  },
  Slash: {
    display: 'flex',
    justifyContent: 'center',
    color: '#bbbbbb',

    fontWeight: 'bold',
    fontSize: '24px',

    padding: '0 15px',
  },
  currentSize: {
    display: 'flex',
    justifyContent: 'center',
    color: '#3cc0c3',

    fontWeight: 'bold',
    fontSize: '24px',
  },
  bloodTest: {
    // height: '85px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    color: '#3cc0c3',

    fontWeight: 'bold',
    fontSize: '16px',

    margin: 0,
    // marginTop:'8px',
    padding: '0 15px',
  },
  success: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    color: '#753cbe',

    fontWeight: 'bold',
    fontSize: '16px',
  },
  number: {
    fontSize: '12px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#707070',
    marginTop: '3px',
  },
  serialNumber: {
    fontSize: '16px',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#707070',
    paddingLeft: '8px',
  },
  lineProfile: {
    width: '90%',
    height: '0px',
    margin: '19px auto',
    border: '1px solid #D8D8D8',
    transform: 'rotate(-0.46deg)',
  },
  Button3Style: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    width: '164px',
    height: '48px',
    padding: '14px 26px 14px 25px',
    boxShadow: '-4px 4px 15px rgba(172, 172, 172, 0.5), 4px -4px 15px #FFFFFF',
    border: '1px solid #FFFFFF !important',
    backgroundColor: '#f5f5f5 !important',
    borderRadius: '16px !important',
    textAlign: 'center',
    margin: 'auto !important',
    marginTop: '16px !important',
    color: '#753cbe',
  },
  containerHelp: {
    color: '#753cbe',
    paddingTop: '15px',
  },
  helpNFCText: {
    fontSize: '16px',

    textAlign: 'center',
    color: '#222222',
    fontWeight: 'normal',
  },

  boldText: {
    fontSize: '16px',

    textAlign: 'center',
    color: '#753cbe',
    fontWeight: 'bold',
  },
  dialogText: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    color: '#d81d5d !important',

    fontSize: '16px !important',
    fontWeight: 'bold !important',
  },
  dialogPurpleText: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    fontSize: '14px !important',

    textAlign: 'center !important',
    color: `#753cbe !important`,
    fontWeight: 'bold !important',
    paddingTop: '30px',
  },
  dialogLongText: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    color: '#222222 !important',

    fontSize: '14px !important',
    fontWeight: 'bold !important',
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
  },
  dialogButtonSupportNfc: {
    height: '40px !important',
    borderRadius: '14px !important',
    boxShadow:
      '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5) !important',
    backgroundColor: '#ffffff !important',
    border: '1px solid #ebebeb !important',
    fontWeight: 'bold !important',

    fontSize: '12px !important',
    padding: ' 10px 23px !important',
  },
  dialogButton: {
    width: '148px !important',
    height: '40px !important',
    borderRadius: '14px !important',
    boxShadow:
      '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5) !important',
    backgroundColor: '#ffffff !important',
    border: '1px solid #ebebeb !important',
    fontWeight: 'bold !important',

    fontSize: '12px !important',
    padding: ' 10px 23px !important',
  },
  dialogFirstButton: {
    width: '94% !important',
    height: '48px',
    borderRadius: '14px !important',
    boxShadow:
      '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5) !important',
    backgroundColor: '#ffffff !important',
    border: '1px solid #ebebeb !important',
    fontWeight: 'bold !important',

    fontSize: '12px !important',
    padding: ' 10px 20px !important',
  },
  DialogNFCText: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    fontSize: '14px',

    textAlign: 'center',
    color: '#222222',
    fontWeight: 'bold',
  },
  dialogSuccessText: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    fontSize: '14px !important',

    textAlign: 'center !important',
    color: '#3bba4c !important',
    fontWeight: 'bold !important',
    paddingTop: '30px',
  },
  dialogErrorText: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    fontSize: '14px !important',

    textAlign: 'center !important',
    color: '#707070 !important',
    fontWeight: 'bold !important',
    paddingTop: '16px',
  },
  noData: {
    color: '#753cbe',
    fontWeight: 'bold',

    marginTop: '20px',
    fontSize: '18px',
  },
  noDataDes: {
    color: '#4e4e4e',
    fontWeight: 'normal',

    padding: '10px',
    fontSize: '16px',
    width: '100%',
  },
  noDataIcon: {
    marginTop: '30px',
  },
  helpContainer: {
    // position: 'relative',
    // top: '64px'
  },
  lineScan: {
    width: '70%',
    height: '0px',
    margin: '19px auto',
    border: '1px solid #D8D8D8',
    transform: 'rotate(-0.46deg)',
  },
  scanAgain: {
    textAlign: 'center',
    fontSize: '18px',
    fontFamily: 'dana-bold',

    marginTop: '44px',
  },
  countdown: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#D81D5D',
    marginTop: '11px',
    fontSize: '14px',
  },
  scanText: {
    textAlign: 'center',
    color: '#3CC0C3',
    fontSize: '14px',
    fontFamily: 'dana-bold',
  },
  scanRedText: {
    textAlign: 'center',
    color: '#D81D5D',
    fontSize: '14px',
    fontFamily: 'dana-bold',
  },
  dialogButtonDoubel: {
    width: '135px !important',
    height: '48px !important',
    backgroundColor: '#f5f5f5 !important',
    border: '1px solid #FFFFFF !important',
    boxShadow:
      '-4px 4px 15px rgba(172, 172, 172, 0.5), 4px -4px 15px #FFFFFF !important',
    borderRadius: '16px !important',
    fontSize: '16px !important',
    fontFamily: 'dana-bold',

    margin: '5px !important',
  },
  buttonContainerButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '28px',
  },
  greenTick: {
    width: '58px',
    height: '42px',
    display: 'grid',
  },
  noNfcText: {
    textAlign: 'center',
    color: '#D81D5D',
    fontSize: '16px',
    fontFamily: 'dana-bold',

    lineHeight: '25px',
    padding: '0 36px',
    marginTop: '54px',
  },
  noNfcHelpText: {
    textAlign: 'center',
    color: '#6F4D9F',
    fontSize: '14px',
    fontFamily: 'dana-bold',

    lineHeight: '22px',
    padding: '0 30px',
    marginTop: '57px',
  },
};

export default ScanStyle;
